<script>
import HamletTable from "@core/components/common/HamletTable.vue";
import Button from "@core/components/common/Button.vue";
import {BFormCheckbox} from 'bootstrap-vue'

export default {
    components: {Button, HamletTable, BFormCheckbox},
    props: {
        borderVariant: {
            default: ''
        },
        organizationLegislations: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            config: null,
            fetchCallback: null,
            columns: [
                {
                    key: 'title',
                    label: this.$t('Component(Grid):column-title'),
                },
                {
                    key: 'active',
                    class: 'text-center',
                    tdClass: 'text-center',
                    label: this.$t('Component(Grid):column-active'),
                },
            ]
        }
    },
    methods: {
        fetch(config, cb) {
            const start = (config.page - 1) * config.perPage;

            cb(
                this.organizationLegislations.length,
                this.organizationLegislations.slice(start, start + config.perPage)
            );
        },
        onTableCreated(config, cb, showLoader) {
            this.config = config;
            this.fetchCallback = cb;
        },
    },
    watch: {
        organizationLegislations() {
            this.fetch(this.config, this.fetchCallback);
        }
    }
}
</script>

<template>
    <div>
        <HamletTable
            :border-variant="borderVariant"
            :columns="columns"
            :fetch="fetch"
            :show-paging-when-empty="false"
            :show-empty-message="false"
            :default-per-page="30"
            @created="onTableCreated"
        >
            <template #header-label>
                {{ $t('Component(OrganizationLegislationSettings):legislation-selector-label') }}
            </template>

            <template #cell-title="data">
                {{ data.item.legislation.title }}
            </template>

            <template #cell-active="data">
                <b-form-checkbox
                    inline
                    switch
                    class="text-center"
                    v-model="data.item.isActive"
                />
            </template>
        </HamletTable>
    </div>
</template>
